module.exports = __webpack_public_path__ + "afe5c9ab56bc7c5635ebdb035d98ce65.jpg";